module.exports = __webpack_public_path__ + "img/4-5porte.3ea207b1.svg";